import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError, withInvalidate } from '@/react-tools/react-query';

import { Team, TeamId } from '../types';

import { buildUrl } from './build-url';
import { teamQueryKeys } from './query-keys';

interface UpdatePayload {
  id: TeamId;
  denyPortainerAccess: boolean;
}

export function useUpdateTeamMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTeam,
    ...withError('Failed to update team'),
    ...withInvalidate(queryClient, [teamQueryKeys.base()]),
  });
}

export async function updateTeam({ id, denyPortainerAccess }: UpdatePayload) {
  try {
    const { data: team } = await axios.put<Team>(buildUrl(id), {
      denyPortainerAccess,
    });
    return team;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to update team');
  }
}
